import { apiFetchVeyaTeam, setVeyaTeamToken } from "./api";

export async function loginVeyaTeam(data) {
  const res = await apiFetchVeyaTeam("/veya-team/auth/login", {
    method: "POST",
    body: JSON.stringify(data),
  });

  setVeyaTeamToken(res.access_token);
  return res.user;
}